/* eslint-disable @typescript-eslint/no-explicit-any */

class Endpoint {
  private PRIVATE = '/private';
  private isPrivate: boolean;

  public endpoint: string;
  public endpointTemplate: string;
  public start: string;
  public end: string;

  constructor(_endpoint: string, isPrivate: boolean = false) {
    this.start = '';
    this.end = '';
    this.endpoint = `${isPrivate ? this.PRIVATE : ''}${_endpoint}`;
    this.endpointTemplate = `${isPrivate ? this.PRIVATE : ''}${_endpoint}`;
    this.isPrivate = isPrivate;
  }

  addParams(params: Array<any>) {
    this.endpoint = this.endpointTemplate;
    params.forEach((p, index) => {
      this.endpoint = this.endpoint.replace(
        `%${index + 1}s`,
        typeof p !== 'string' ? String(p) : p,
      );
    });

    return this;
  }

  addBaseUrl() {
    this.start = `${process.env.BACKEND.host}${
      process.env.BACKEND.port ? ':' + process.env.BACKEND.port : ''
    }${process.env.BACKEND.context}`;
    return this;
  }

  addCsrf(csrf?: string) {
    if (csrf) {
      this.end = this.endpoint.includes('?') ? `&t=${csrf}` : `?t=${csrf}`;
    }
    return this;
  }

  getUrl() {
    return `${this.start}${this.endpoint}${this.end}`;
  }

  isPublic(): boolean {
    return !this.isPrivate;
  }
}

export class PrivateEndpoint extends Endpoint {
  constructor(_endpoint: string) {
    super(_endpoint, true);
  }
}

export class PublicEndpoint extends Endpoint {
  constructor(_endpoint: string) {
    super(_endpoint, false);
  }
}
